module.exports = __webpack_public_path__ + "img/flower-blossum.7ba52bc6.jpg";